<template>
  <div class="n-modal">
    <div class="n-modal__background" @click="emit('cancel')"></div>
    <div class="n-modal__modal">
      <header class="n-modal__header">
        <slot name="title"></slot>
        <button @click="emit('cancel')" class="n-modal__close-button" aria-label="close"></button>
      </header>
      <section class="n-modal__body">
        <slot name="body"></slot>
      </section>
      <footer class="n-modal__footer">
        <slot name="buttons"></slot>
      </footer>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'n-modal',
});

const emit = defineEmits<{
  (e: 'cancel'): void;
}>();
</script>

<style lang="scss" scoped>
@use '../../../styles/colours' as *;
.n-modal {
  align-items: center;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  overflow: hidden;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 40;
  .n-modal__modal {
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 40px);
    overflow: hidden;
    @media screen and (min-width: 769px) {
      margin: 0 auto;
      width: 640px;
    }
  }
  .n-modal__background {
    background-color: rgba(10, 10, 10, 0.6);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
  .n-modal__close-button {
    background-color: rgba(10, 10, 10, 0.2);
    border-radius: 100%;
    border: none;
    cursor: pointer;
    display: inline-block;
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 0;
    height: 20px;
    margin-left: auto;
    pointer-events: auto;
    position: relative;
    width: 20px;
    &::before,
    &::after {
      background-color: #fff;
      content: '';
      display: block;
      left: 50%;
      position: absolute;
      top: 50%;
      transform-origin: center center;
      transform: translateX(-50%) translateY(-50%) rotate(45deg);
    }
    &::before {
      height: 2px;
      width: 50%;
    }
    &::after {
      height: 50%;
      width: 2px;
    }
    &:hover {
      background-color: colourScheme('danger');
    }
  }
  .n-modal__header,
  .n-modal__footer {
    align-items: center;
    background-color: colourScheme('light-grey');
    display: flex;
    flex-shrink: 0;
    justify-content: flex-start;
    padding: 20px;
    position: relative;
  }
  .n-modal__header {
    border-bottom: 1px solid colourScheme('grey', 'light');
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .n-modal__body {
    -webkit-overflow-scrolling: touch;
    background-color: #fff;
    flex-grow: 1;
    flex-shrink: 1;
    overflow: auto;
    padding: 20px;
    z-index: 50;
  }
  .n-modal__footer {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-top: 1px solid colourScheme('grey', 'light');
    .btn {
      margin-right: 0.5em;
    }
  }
}
</style>
